import DeleteApiKeyConfirmationModalContent from "v2/api-key-management/components/modals/DeleteApiKeyConfirmationModalContent";


export const path = "confirm-delete";

export const Component = DeleteApiKeyConfirmationModalContent;
